import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SegmentedToggleOption } from '../../ui/segmented-toggle/segmented-toggle.component';

export interface TabItem {
  id: string;
  label: string;
  icon?: string;
  iconHtml?: string;
  isActive?: boolean;
  isVisible?: boolean;
  content?: any;
}

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {
  @Input() tabs: TabItem[] = [];
  @Input() activeTabId: string = '';
  @Input() tabClasses: string = '';
  @Output() tabChange = new EventEmitter<TabItem>();

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    if (!this.activeTabId && this.tabs.length > 0) {
      const visibleTab = this.tabs.find(tab => tab.isVisible !== false);
      if (visibleTab) {
        this.activeTabId = visibleTab.id;
      }
    }
  }

  get toggleOptions(): SegmentedToggleOption[] {
    return this.tabs
      .filter(tab => tab.isVisible !== false)
      .map(tab => ({ label: tab.label, value: tab.id, iconHtml: tab.iconHtml }));
  }

  onToggleChange(tabId: string) {
    this.activeTabId = tabId;
    const tab = this.tabs.find(t => t.id === tabId);
    if (tab) {
      this.tabChange.emit(tab);
    }
  }

  isTabActive(tabId: string): boolean {
    return this.activeTabId === tabId;
  }

  htmlProperty(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}